import { v4 as uuidV4 } from 'uuid';

export function uuid(): string {
  return uuidV4();
}

export function sleep(delay: number = 0): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
}
